import { useServiceContainer } from '@aesop-fables/containr-react';
import { ICommandExecutor, ScriniumServices } from '@aesop-fables/scrinium';

export function useCommands() {
  const container = useServiceContainer();
  return container.get<ICommandExecutor>(ScriniumServices.CommandExecutor);
}
